import React, {
    useState,
    useCallback,
    useContext,
    useEffect,
    useMemo,
} from "react";
import _, { get } from "lodash";
import PropTypes from "prop-types"
import {  withViewModelService,ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';

;
import { withRouter } from "react-router-dom";
import { useTranslator } from "@jutro/locale";
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { ServiceRequestService } from "gw-capability-servicerequest";
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import {  ModalNextContext } from "@jutro/components";
import { LoaderExt } from 'gw-components-platform-react';
import moment from "moment";
import PayrollService from "cpmi-capability-payroll/services/PayrollService";
import useGoogleAnalytics from "account-management/src/hooks/useGoogleAnalytics";
import metadata from "./PayrollReview.metadata.json5";
import messages from "./PayrollReview.messages";
import styles from "./PayrollReview.module.scss";
import PayrollInvoiceTable from './PayrollInvoiceTable/PayrollInvoiceTable';

function PayrollReview(props) {
    
    const viewModelService = useContext(ViewModelServiceContext);
    const translator = useTranslator();
    const { authHeader } = useAuthentication();
    const [state,setStateName]=useState([]);
    const [isLoading, setLoadingState] = useState(false);
    const [viewStartPage, setviewStartPage] = useState(true);
    const [trackGAPageView]=useGoogleAnalytics();
    const [draftData,setDraftData]=useState({})
    const ModalNext = useContext(ModalNextContext);

    const { history } = props;
    const {onCallback,DraftDataFromReview} = props;
    const appValue=props?.location?.state?.appValue
    let reviewData;
    let totalsArray =[];
    if(appValue==="CE")
    {
        reviewData = _.get(props, "location.state.data");    
    }
    else{
        reviewData = _.get(props, "data");
       
    }

    useEffect(() => {
        trackGAPageView("/payroll-reporting/review","Payroll Review")
    },[])
    

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const individualData=reviewData?.policyPremium!==undefined?reviewData?.policyPremium?.individualCosts:[]
    
    const handleSubmit = useCallback(() => {
        setLoadingState(true)
        ModalNext.showConfirm({
            title: messages.submitTitle,
            message: appValue==="PE"?messages.PEsubmitMessage:messages.submitMessage,
            status: "info",
            icon: "mi-error-outline",
            confirmButtonText: "Submit Report",
            cancelButtonText: "Edit Report",
            closeButton:"false"
        }).then(async (results) => {
            if (results === "confirm") {
                if (appValue === "PE") {
                    await PayrollService.PEsubmitPayrollReport(
                        reviewData?.jobNumber,
                        authHeader
                    );
                    setLoadingState(false)
                    history.push({pathname:props.location.pathname,state:"submitted"})
                } else {
                    await PayrollService.submitPayrollReport(
                        reviewData?.jobNumber,
                        authHeader
                    );
                    setLoadingState(false)
                    history.push({
                        pathname: `/payroll-reporting/list/success`,
                        state: {
                            appValue: "submitted",
                        },
                    });
                }
            } else if(appValue==='PE')
            {
                onCallback(true)
            }
            else{
                history.go(-1);
               
            }
        }, _.noop);
    }, [ModalNext, appValue, authHeader, history, onCallback, reviewData?.jobNumber, reviewData?.policyNumber]);

    const handleMakeChanges = useCallback(async() => {
        if(appValue==='PE')
        {
            const res = await PayrollService.PEchangeReportStatusToDraft(reviewData?.jobNumber,authHeader)
            setDraftData(res)
            setviewStartPage(true);
            onCallback(true)
            // DraftDataFromReview(draftData)
            DraftDataFromReview(props?.data)
        }
        else{
            await PayrollService.changeReportStatusToDraft(reviewData?.jobNumber,authHeader)
            history.go(-1);
        }
          
    }, [DraftDataFromReview, appValue, authHeader, draftData, history, onCallback, reviewData?.jobNumber]);

    const getFormatAmt = (value) => {
        // value=value.toFixed(2)
        var val = Math.round(Number(value) * 100) / 100;

        var parts = val.toFixed(2).split(".");

        var num = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") + (parts[1] ? "." + parts[1] : "");

        return num
    }

    const getTotalAmount = useCallback(() => {
        
        if(reviewData?.policyPremium!==undefined)
        {
            const amount = reviewData?.policyPremium?.totalPremiumOfReport?.amount.toFixed(
                2
            );
            totalsArray.push({description:"Total Policy Premium",amount:`$${  amount}`})
            return <span className={styles.textAlignment}>Total Premium: ${getFormatAmt(amount)}</span>;
        }
        
        return ' '
        
        
    }, [reviewData]);

    const getTotalAmountTop = useCallback(() => {
        
        if(reviewData?.policyPremium!==undefined)
        {
            const amount = reviewData?.policyPremium?.totalPremiumOfReport?.amount?.toFixed(
                2
            );
            totalsArray.push({description:"Total Policy Premium",amount:`$${  amount}`})
            return <span className={styles.textAlignmentTop}>${amount}</span>;
        }
        
        return ' '
        
        
    }, [reviewData]);


    const getPolicyPeriod = useCallback(() => {

        
        const startperiod = moment(reviewData?.reportPeriodStart).format(
            "MM/DD/YYYY"
        );
        const endDate = moment(reviewData?.reportPeriodEnd).format("MM/DD/YYYY");
        if(reviewData?.hasOwnProperty('paymentFrequency')){
            const paymentFrequency= reviewData?.paymentFrequency;
            return `Payroll Period : ${startperiod} - ${endDate} - (${paymentFrequency})`;
        }
        return `Payroll Period : ${startperiod} - ${endDate} `;
       
    }, [reviewData]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const renderDescription=useCallback((item)=>{
        return item.description
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const RenderTotalAmount=useCallback((item)=>{
        return item.amount
    })

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const renderEmpty=useCallback((item)=>{
        return ''
    })
    

    

    const generateOverrides = useMemo(() => {
       
        let overrides={}
        if(appValue==="CE")
        {
            overrides = individualData?.map((item, index) => {
                return {
                    [`invoiceTable${index}`]: {
                        data: individualData[index],
                    },
                  
                    
                };
            });
        }
        else{
            overrides = individualData?.map((item, index) => {
                return {
                    [`invoiceTable${index}`]: {
                        data: individualData[index],
                    },
                  
                    
                };
            });  
        }

        return Object.assign({}, ...overrides);
    }, [appValue, individualData]);

    console.log(individualData);

    const override = {
        
        ...generateOverrides,
        
        policyNumberId: {

            content: `Policy : ${reviewData?.policyNumber}`,
        },
        policyperiodId: {
            content: getPolicyPeriod(),
        },
        totalcostdataId: {
            // value: `$${reviewData.policyPremium.totalPremiumOfReport.amount.toFixed(2)}`
            content: getTotalAmount(),
        },
        totalcostdataIdTop:{
            content: getTotalAmountTop(),
        },
        payrollDetails:{
            data:individualData || []
        },
        // totalDescId:{
        //     value:"Description"
        // },
        // totalAmountId:{
        //     value: getTotalAmount(),
        // }
        payrollTotalTable:{
            visible:false,
            data:totalsArray
        }

    };

    const resolvers = {
        resolveClassNameMap: styles,
        
        resolveCallbackMap: {
            renderDescription:renderDescription,
            RenderTotalAmount:RenderTotalAmount,
            handleMakeChanges: handleMakeChanges,
            handleSubmit: handleSubmit,
            renderEmpty:renderEmpty
        },
        resolveComponentMap:{
            PayrollInvoiceTable:PayrollInvoiceTable
        }
    };

    if (isLoading) {
        return <LoaderExt loaded={!isLoading} />;
    }


    return (
        <MetadataContent
            uiProps={metadata.pageContent}
            overrideProps={override}
            {...resolvers}
        />
    );
}
PayrollReview.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func,
        goBack: PropTypes.func,
        location: PropTypes.shape({
            state: PropTypes.shape({}),
        }),
    }).isRequired,
};

export default withRouter(withViewModelService(PayrollReview));
